export type IconNames = "bike" | "bus" | "bus2" | "trailer" | "truck" | "van";


export default class Icons{
    static AllIconNames: IconNames[] = ["bike", "bus", "bus2", "trailer", "truck", "van"];
}